var _Path, _Circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgWinterSports(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.458 11.918l4.268-2.817-4.433-2.594c-.415-.243-.533-.743-.264-1.119.27-.375.824-.481 1.24-.238l5.005 2.929.978-.647c.797-.448 1.658-.75 2.35-.668.578.071 1.112.354 1.596.906 1.127 1.27 1.82 2.901 2.447 4.72l2.586 1.513.85-.09c1.172-.047 1.726 1.05 1.329 1.782a.749.749 0 01-.144.463c-.27.375-.824.481-1.24.238l-.07-.042-2.443.243c-1.318.134-2.28.462-2.996-.878l-1.52-3.438-.198-.116-4.495 2.825c-.285.269-.327.533-.042.802l3.46 2.27c.454.277.839.473.933 1.025.128.743-2.699 5.348-3.774 7.056l6.046 2.761c1.012.397 1.854.562 2.51.48.505-.062.924-.314 1.248-.765.45-.623 1.373-.8 2.066-.397.69.406.889 1.24.439 1.865-.826 1.15-1.95 1.796-3.352 1.968-1.206.149-2.576-.087-4.106-.687a1.428 1.428 0 01-.167-.066L2.822 22.185c-.738-.336-1.033-1.147-.662-1.81.372-.666 1.271-.933 2.006-.598l10.405 4.753 2.78-4.488c-.782-.42-1.54-.84-2.27-1.26-2.435-1.395-5.675-4.593-2.623-6.864z",
    fill: "#333"
  })), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 28,
    cy: 6,
    r: 3,
    fill: "#333"
  })));
}

export default SvgWinterSports;